<template>
  <footer class="footer" id="footer">
    <BlogNewsCarousel :footer="true" />
    <div class="footer-content container">
      <div class="footer-newsletter">
        <h2 class="footer-newsletter__title">Assine nossa newsletter</h2>
        <h3 class="footer-newsletter__subtitle">
          Receba nossas promoções e novidades antecipadamente.
        </h3>
        <div class="footer-newsletter__box">
          <input
            v-model="form.nome"
            minlength="3"
            class="footer-newsletter__box__input"
            type="text"
            placeholder="Seu nome"
          />
          <input
            v-model="form.email"
            minlength="5"
            class="footer-newsletter__box__input"
            type="email"
            placeholder="Seu e-mail"
          />
          <button
            @click="sendNews"
            type="submit"
            class="footer-newsletter__box__btn"
          >
            {{ buttonText }}
          </button>
        </div>
        <ModalConfirm :show="show" :msg="msg" />
      </div>

      <ul class="footer-socials">
        <li>
          <a
            class="footer-socials__link"
            href="https://www.facebook.com/FibrillareOficial"
            target="_blank"
            ><img src="@/assets/icons/facebook.svg" alt=""
          /></a>
        </li>
        <li>
          <a
            class="footer-socials__link"
            href="https://www.instagram.com/fibrillare_moveis/"
            target="_blank"
            ><img src="@/assets/icons/instagram.svg" alt=""
          /></a>
        </li>
        <li>
          <a
            class="footer-socials__link"
            href="https://api.whatsapp.com/send?phone=5543999590178"
            target="_blank"
            ><img src="@/assets/icons/whats.svg" alt=""
          /></a>
        </li>
      </ul>
      <div class="footer-contact">
        <div class="footer-contact__item">
          <img src="@/assets/icons/fone.svg" alt="" />
          <span>{{ $root.commonTexts.telefone }}</span>
        </div>
        <div class="footer-contact__item">
          <img src="@/assets/icons/mail.svg" alt="" />
          <span>{{ $root.commonTexts["contact.email"] }}</span>
        </div>
      </div>
      <div class="footer-info">
        <p>
          Rua Juriti, 126 – Portão 19/ Vila industrial – Arapongas/PR Cep:
          86706-010
        </p>
        <p>               
          <router-link class="privacy" to="/privacidade">Política de privacidade</router-link>
        </p>
      </div>
      <div class="footer-copy">
        <p>
          © Copyright {{ currentYear }}, {{ $root.commonTexts.razao }} - CNPJ:
          {{ $root.commonTexts.cnpj }}. Todos os direitos reservados.
        </p>
        <a class="azul" href="https://www.gk2.cloud" target="_blank"
          >Desenvolvido por GK2.CLOUD</a>
      </div>
    </div>
    <Popup />
  </footer>
</template>

<script>
import BlogNewsCarousel from "../Shared/BlogNewsCarousel";
import Blog from "../../views/Blog";
import ModalConfirm from "../Shared/ModalConfirm";
import Popup from "../Shared/Popup.vue";
export default {
  name: "Footer",
  data() {
    return {
      buttonText: "Enviar",
      form: {
        nome: "",
        email: "",
      },
      show: false,
      msg: "",
    };
  },
  methods: {
    sendNews(e) {
      e.preventDefault();
      this.buttonText = "Enviando...";
      axios
        .post("/newsletter", this.form)
        .then(() => {
          this.buttonText = "Enviar";
          this.show = true;
          this.msg = "Seu e-mail foi adicionado a nossa newsletter.";
          setTimeout(() => {
            this.show = false;
            this.$router.push("/").catch(() => {});
            this.form.email = "";
            this.form.nome = "";
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }, 2000);
        })
        .catch(() => {
          this.buttonText = "Enviar";
          this.show = true;
          this.msg = "Houve um erro ao adicionar o e-mail.";
          setTimeout(() => {
            this.show = false;
          }, 2000);
        });
    },
  },

  computed: {
    currentYear() {
      const year = new Date();
      return year.getFullYear();
    },
  },
  components: {
    ModalConfirm,
    Blog,
    BlogNewsCarousel,
    Popup,
  },
};
</script>

<style lang="scss" scoped>
.footer {
  margin-top: 120px;
  background: #1d1d1d;
}

.footer-newsletter {
  padding-top: 60px;
  color: #fff;

  &__title {
    text-align: center;
    font-size: 2.25rem;
    font-weight: 500;
    font-family: HelveticaNeue, Arial, sans-serif;
  }

  &__subtitle {
    text-align: center;
    margin-top: 15px;
    font-size: 1.125rem;
    font-weight: 500;
    font-family: HelveticaNeueLight, Arial, sans-serif;
  }

  &__box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 35px;

    &__input {
      width: 100%;
      margin-right: 30px;
      border: none;
      border-radius: 4px;
      padding: 10px 0 10px 10px;
      font-size: 1rem;
      font-family: "Open Sans";

      &::placeholder {
        color: #aaa;
      }
    }

    &__btn {
      cursor: pointer;
      border: none;
      outline: none;
      padding: 10px 60px;
      background: #2b2b2b;
      border-radius: 4px;
      color: #fff;
      font-size: 1rem;
      font-family: "Poppins", Arial, sans-serif;
    }
  }
}

.footer-socials {
  margin-top: 60px;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;

  &__link {
    display: block;
    padding: 5px;
    margin-right: 5px;
  }
}

.footer-contact {
  display: flex;
  justify-content: center;

  &__item {
    display: flex;
    align-items: center;
    margin-right: 40px;
    color: #fff;

    img {
      margin-right: 10px;
    }

    span {
      font-family: "Open Sans", Arial, sans-serif;
      font-size: 1rem;
      font-weight: 300;
    }
  }
}

.footer-info {
  margin-top: 20px;
  text-align: center;
  color: #fff;

  p {
    font-family: "Open Sans", Arial, sans-serif;
    font-size: 1rem;
    font-weight: 300;
  }
}

.footer-copy {
  margin-top: 30px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  padding-bottom: 40px;

  p {
    margin-right: 5px;
    font-family: "Open Sans", Arial, sans-serif;
    font-size: 0.75rem;
  }
}

  .privacy{
    align-items: center;
    color: #fff;
    display: flex;
    justify-content: center;
    text-decoration: underline;
  }

.azul {
  img {
    margin-left: 5px;
  }

  display: flex;
  align-items: center;
  color: #fff;
  margin-top: 0px;
  font-size: 0.75rem;
  font-family: "Open Sans";
}

@media only screen and (max-width: 767px) {
  .footer-newsletter__title {
    font-size: 1.5rem;
  }

  .footer-newsletter__subtitle {
    font-size: 0.875rem;
  }

  .footer-newsletter__box {
    flex-direction: column;
    justify-content: center;

    &__input {
      margin-bottom: 10px;
    }

    &__btn {
      margin-top: 10px;
    }
  }

  .footer-socials {
    margin-top: 40px;
  }

  .footer-contact {
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &__item {
      margin-right: 0;
      margin-bottom: 15px;
      font-size: 0.75rem;
    }
  }

  .footer-info p {
    font-size: 0.75rem;
  }

  .footer-copy {
    flex-direction: column;
    justify-content: center;

    a {
      margin-bottom: 30px;
    }
  }

  .azul {
    img {
      margin-left: 5px;
    }

    display: flex;
    color: #fff;
    margin-top: 30px;
    font-size: 0.75rem;
    font-family: "Open Sans";
  }
}

@media only screen and (max-width: 767px) {
  .footer {
    margin-top: 60px;
  }

  .footer-newsletter {
    padding-top: 80px;
  }
}
</style>
